// extracted by mini-css-extract-plugin
export default {"root":"contentShell_root__WVbZI","content":"contentShell_content__r7JC6"};